import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'

Vue.use(Vuex)

const state = {
  // 用户的基本信息
  userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {
    // 管理员一类的角色列表
    admin_role: [],
    // 员工一类的角色列表
    clerk_role: [],
    token: '',
    // 角色：[ 超级管理员(super), 老板 (boss)，员工(manager) ]
    role: '',
    // 用户名
    username: ''
  }
}

const options = {
  state,
  mutations,
  actions,
  modules: {
  }
}

export default new Vuex.Store(options)



// WEBPACK FOOTER //
// ./src/store/index.js